export const CAPABILITIES = Object.freeze({
  PREMIUM_RESEARCH: "premiumResearch",
  TEG: "teg",
  MSI: "msi",
  TEG_GURU_PLAYS: "tegGuruPlays",
  MSI_GURU_PLAYS: "msiGuruPlays",
  TEG_PLAY_ALERTS: "tegPlayAlerts",
  MSI_PLAY_ALERTS: "msiPlayAlerts",
  EXPORT: "export",
  PWG_GURU_MODE: "pwgGuruMode",
  PWG_ALTERNATE_LINES: "pwgAlternateLines",
  PWG_GOBLIN_LINES: "pwgGoblinLines",
  PWG_DEMON_LINES: "pwgDemonLines",
  PWG_PROMO_LINES: "pwgPromoLines",
  PWG_LINE_TYPE_FILTERS: "pwgLineTypeFilters",
  PWG_ATTAINABILITY: "pwgAttainability",
  PWG_PRIMARY_LINE_COMPARISON: "pwgPrimaryLineComparison",
  PWG_ADVANCED_FILTERS: "pwgAdvancedFilters",
});

export const PWG_GURU_MODE_FEATURES = Object.freeze([
  "alternateLines", "goblinLines", "demonLines", "promoLines",
  "lineTypeFilters", "attainability", "primaryLineComparison", "advancedFilters",
]);

export function resolvePwgGuruMode({ isAdmin = false, applications = {} } = {}) {
  const configured = applications?.PWG?.capabilities?.guruMode || {};
  const enabled = isAdmin || configured.enabled === true;
  const feature = (key) => isAdmin || (enabled && configured.features?.[key] !== false);
  const alternateLines = feature("alternateLines");
  return Object.freeze({
    enabled,
    alternateLines,
    goblinLines: alternateLines && feature("goblinLines"),
    demonLines: alternateLines && feature("demonLines"),
    promoLines: alternateLines && feature("promoLines"),
    lineTypeFilters: feature("lineTypeFilters"),
    attainability: feature("attainability"),
    primaryLineComparison: feature("primaryLineComparison"),
    advancedFilters: feature("advancedFilters"),
  });
}

export function hasApplicationFeature(applications, source, feature) {
  const application = applications?.[String(source || "").toUpperCase()];
  return application?.enabled === true && application?.features?.[feature]?.enabled === true;
}

export function buildCapabilities({ isAdmin = false, isPremium = false, applications = {} } = {}) {
  const paid = isAdmin || isPremium;
  const guruMode = resolvePwgGuruMode({ isAdmin, applications });
  return Object.freeze({
    [CAPABILITIES.PREMIUM_RESEARCH]: paid,
    [CAPABILITIES.TEG]: applications.TEG?.enabled === true,
    [CAPABILITIES.MSI]: applications.MSI?.enabled === true,
    [CAPABILITIES.TEG_GURU_PLAYS]: isAdmin || hasApplicationFeature(applications, "TEG", "guruPlays"),
    [CAPABILITIES.MSI_GURU_PLAYS]: isAdmin || hasApplicationFeature(applications, "MSI", "guruPlays"),
    [CAPABILITIES.TEG_PLAY_ALERTS]: hasApplicationFeature(applications, "TEG", "playAlerts"),
    [CAPABILITIES.MSI_PLAY_ALERTS]: hasApplicationFeature(applications, "MSI", "playAlerts"),
    [CAPABILITIES.EXPORT]: paid && applications.PWG?.enabled === true,
    [CAPABILITIES.PWG_GURU_MODE]: guruMode.enabled,
    [CAPABILITIES.PWG_ALTERNATE_LINES]: guruMode.alternateLines,
    [CAPABILITIES.PWG_GOBLIN_LINES]: guruMode.goblinLines,
    [CAPABILITIES.PWG_DEMON_LINES]: guruMode.demonLines,
    [CAPABILITIES.PWG_PROMO_LINES]: guruMode.promoLines,
    [CAPABILITIES.PWG_LINE_TYPE_FILTERS]: guruMode.lineTypeFilters,
    [CAPABILITIES.PWG_ATTAINABILITY]: guruMode.attainability,
    [CAPABILITIES.PWG_PRIMARY_LINE_COMPARISON]: guruMode.primaryLineComparison,
    [CAPABILITIES.PWG_ADVANCED_FILTERS]: guruMode.advancedFilters,
  });
}
